import { connect } from "react-redux";

import CitiesHistogramTable from "../../components/visualizations/cities_histogram_table";

const mapStateToProps = (state) => {
  const ld = state.main.loading.loadedData;
  if (!(ld.mainTableData)) { return {}; }

  const data = ld.mainTableData;

  return { data };
};

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(CitiesHistogramTable);
